import React, { lazy } from 'react';
import { RouterProps } from '../shared/types/route.type';
import { AppRoutes } from './routeConstants/appRoutes';
import FarmProductPage from '../views/FarmProductPage';
import FarmOutlet from '../shared/components/FarmOutlet';
import FarmRawMaterials from '../views/FarmCreationFlow/RawMaterials';
import FarmCommodityDistribution from '../views/FarmCreationFlow/FarmCommodityDistribution';
import FarmFuelAndEnergy from '../views/FarmCreationFlow/FuelAndEnergy';
import FarmTransportation from '../views/FarmCreationFlow/Transportation';
import FarmOverviewPage from '../views/FarmOverviewPage';
import FarmField from '../views/FarmCreationFlow/Fields';
import PrivateRoute from '../shared/components/PrivateRoute';
const ManureManagement = lazy(
  () => import('views/LiveStockCreationFlow/ManureManagement')
);
const LiveStockFarmFuelAndEnergy = lazy(
  () => import('views/LiveStockCreationFlow/FuelAndEnergy')
);
const LiveStockOutlet = lazy(
  () => import('views/LiveStockCreationFlow/LiveStockOutlet')
);
const GrowthStage = lazy(
  () => import('views/LiveStockCreationFlow/GrowthStage')
);
const LiveStockFeed = lazy(
  () => import('views/LiveStockCreationFlow/LiveStockFeed')
);
const LiveStockCommodityDistribution = lazy(
  () => import('views/LiveStockCreationFlow/CommodityDistribution')
);
const FarmLiveStockOverviewPage = lazy(
  () => import('views/FarmLiveStockOverviewPage')
);

export const farmboxRoutes: RouterProps[] = [
  {
    path: AppRoutes.FARMBOX,
    element: (
      <PrivateRoute>
        <FarmProductPage />
      </PrivateRoute>
    ),
    children: [
      {
        path: AppRoutes.STATUS_ROUTE,
        element: <FarmProductPage />,
      },
    ],
  },
  {
    path: AppRoutes.FARM_CREATION,
    element: (
      <PrivateRoute>
        <FarmOutlet />
      </PrivateRoute>
    ),
    children: [
      {
        path: AppRoutes.FARM_RAW_MATERIAL,
        element: <FarmRawMaterials />,
      },
      {
        path: AppRoutes.FARM_FUEL_AND_ENERGY,
        element: <FarmFuelAndEnergy />,
      },
      {
        path: AppRoutes.FARM_TRANSPORTATION,
        element: <FarmTransportation />,
      },
      {
        path: AppRoutes.FARM_FIELD,
        element: <FarmField />,
      },
      {
        path: AppRoutes.FARM_COMMODITY_DISTRIBUTION,
        element: <FarmCommodityDistribution />,
      },
      {
        path: AppRoutes.FARM_OVERVIEW_PAGE,
        element: <FarmOverviewPage />,
      },
    ],
  },
  {
    path: AppRoutes.FARM_LIVE_STOCK_CREATION,
    element: (
      <PrivateRoute>
        <LiveStockOutlet />
      </PrivateRoute>
    ),
    children: [
      {
        path: AppRoutes.FARM_LIVE_STOCK_GROWTH_STAGE,
        element: <GrowthStage />,
      },
      {
        path: AppRoutes.FARM_LIVE_STOCK_FUEL_AND_ENERGY,
        element: <LiveStockFarmFuelAndEnergy />,
      },
      {
        path: AppRoutes.FARM_LIVE_STOCK_FEED,
        element: <LiveStockFeed />,
      },
      {
        path: AppRoutes.FARM_LIVE_STOCK_MANURE_MANAGEMENT,
        element: <ManureManagement />,
      },
      {
        path: AppRoutes.FARM_LIVE_STOCK_COMMODITY_DISTRIBUTION,
        element: <LiveStockCommodityDistribution />,
      },
      {
        path: AppRoutes.FARM_LIVE_STOCK_OVERVIEW,
        element: <FarmLiveStockOverviewPage />,
      },
    ],
  },
];
